import React from 'react'
import { Icon, Flex } from '@ui'
import css from './detailsTableLabel.module.scss'

interface IProps {
  label: React.ReactNode
  iconName: string
  rightItem?: React.ReactNode
  leftItem?: React.ReactNode
  iconItem?: React.ReactNode
}

export default function Header({ label, iconName, rightItem, leftItem, iconItem }: IProps) {
  return (
    <Flex justify="space-between" align="center">
      <Flex align="center">
        <div className={css.s_header}>
          <div>
            {iconItem ? iconItem : <Icon name={iconName} />}
            {label}
          </div>
        </div>
        {leftItem}
      </Flex>
      {rightItem}
    </Flex>
  )
}
